import styled from 'styled-components';

export const Container = styled.div`
  height: 98.40%;
  width: 99.90%;
  display: grid;
  grid-template-columns: 300px 1fr; ;
`;
